<template>
  <div>
    <h5 class="header-stripe">
      <span>{{header}}</span>
      <div class="action">
        <Button type="primary" size="mini" :disabled="!booked"
          @click="submit">{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Checkbox v-model="booked" class="pb-5">
        <span class="text-md">Confirm Booking</span>
      </Checkbox>
      <Form :inline="true" class="form-default form-triple">
        <div class="form-item-group">
          <FormItem :label="$t('BOOKING_NUMBER')">
            <Input
              placeholder="Enter Booking Number"
              size="small"
              v-model="bookingNumber"
              class="form-control"
            />
          </FormItem>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    header: {
      type: String,
    },
    currentOrder: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      booked: false,
      bookingNumber: '',
    };
  },
  methods: {
    submit() {
      this.$emit('confirm-booking', this.bookingNumber);
    },
  },
};
</script>
